
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-red-900 to-red-800 backdrop-blur-sm shadow-lg z-50">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-3 mr-8">
              <span className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-500 drop-shadow-lg" style={{ fontFamily: '"Times New Roman", "Georgia", serif' }}>
                CASTLE & CASTLE MARKETING AGENCY
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-300 transition-colors cursor-pointer font-bold"
            >
              About
            </button>
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-300 transition-colors cursor-pointer font-bold"
            >
              Services
            </button>
            <button 
              onClick={() => document.getElementById('publicity')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-300 transition-colors cursor-pointer font-bold"
            >
              Publicity
            </button>
            <button 
              onClick={() => document.getElementById('showcase')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-300 transition-colors cursor-pointer font-bold"
            >
              Showcase
            </button>
            <button 
              onClick={() => document.getElementById('clients')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-3 transition-colors cursor-pointer font-bold"
            >
              Clients
            </button>
            <button 
              onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-3 transition-colors cursor-pointer font-bold"
            >
              Testimonials
            </button>
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-red-100 hover:text-amber-3 transition-colors cursor-pointer font-bold"
            >
              Contact
            </button>
          </div>

          <div className="hidden lg:block ml-8">
            <Button onClick={() => scrollToSection('contact')} variant="secondary">
              Schedule Free Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-red-100`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-red-700">
            <div className="flex flex-col space-y-4 pt-4">
              <button onClick={() => scrollToSection('about')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">About</button>
              <button onClick={() => scrollToSection('services')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Services</button>
              <button onClick={() => scrollToSection('publicity')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Publicity</button>
              <button onClick={() => scrollToSection('showcase')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Showcase</button>
              <button onClick={() => scrollToSection('clients')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Clients</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Testimonials</button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-red-100 hover:text-amber-3 transition-colors cursor-pointer">Contact</button>
              <Button onClick={() => scrollToSection('contact')} variant="secondary" className="mt-4">
                Schedule Free Consultation
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
